import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
    websiteInfo:{},
    websiteData: {},
    isMobile: false,
    isHaveBanner: false,
    modulesData: [],
    requestInfo: {
        ip: '',
        terminal: '',
        userAgent: '',
        url: ''
    }
}
const mutations = {
    setIsMobile(state, payload) {
        state.isMobile = payload
    },
    setIsHaveBanner(state, payload) {
        state.isHaveBanner = payload
    },
    setModulesData(state, payload) {
        if (Array.isArray(payload)) {
            state.modulesData = payload
        }
    },
    setWebsiteData(state, payload) {
        state.websiteData = payload
    },
    setRequestInfo(state, payload) {
        state.requestInfo = Object.assign(state.requestInfo, payload)
    },
    setWebsiteInfo(state,val){
      state.websiteInfo = val
    }
}
const actions = {
    commitIsMobile({
        commit
    }, payload) {
        commit('setIsMobile', payload)
    },
    commitIsHaveBanner({
        commit
    }, payload) {
        commit('setIsHaveBanner', payload)
    },
    commitModulesData({
        commit
    }, payload) {
        commit('setModulesData', payload)
    },
    commitWebsiteData({
        commit
    }, payload) {
        let websiteData = {
            backgroundColor:'',
            color:''
        }
        commit('setWebsiteData', websiteData)
    }
}

export default new Vuex.Store({
    state: state,
    mutations:mutations,
    actions:actions
})



// WEBPACK FOOTER //
// ./src/store/index.js